// extracted by mini-css-extract-plugin
module.exports = {"cardContainer":"card_cardContainer__2lTsv","title":"card_title__FuOTG","inActive":"card_inActive__1ffby"};